export enum StatusItemBudget {
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
  SENT = "SENT",
  DENIED = "DENIED",
}
